// extracted by mini-css-extract-plugin
export var btnIcon = "styles-module--btnIcon--aQGS6";
export var btnIconWrapper = "styles-module--btnIconWrapper--BDyLr";
export var btnWrapper = "styles-module--btnWrapper--onNCf";
export var contentWrapper = "styles-module--contentWrapper--prRRr";
export var description = "styles-module--description--yaSpJ";
export var pageHeader = "styles-module--pageHeader--DjBYg";
export var pageHeaderImage = "styles-module--pageHeaderImage--i4jvY";
export var title = "styles-module--title--NcgVu";
export var xyz = "styles-module--xyz--K-JUn";